import AssessmentsOverviewWidget from "./AssessmentsOverviewWidget";

export default AssessmentsOverviewWidget;